module.exports = __webpack_public_path__ + "dbac2bdf6b640ef63c0a9460be4f791b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/filter_tag_2x.png
// module id = 35
// module chunks = 0 1 2 3 4